export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Positive"] = "Positive";
    FeedbackType["Negative"] = "Negative";
})(FeedbackType || (FeedbackType = {}));
//# sourceMappingURL=entity-summary.js.map